import React, { useEffect } from "react";
import { BankGuaranteeIssuanceDocuments } from "./BankGuaranteeIssuanceDocuments/BankGuaranteeIssuanceDocuments";
import { Button, DatePicker, Divider, Form, Input } from "antd";
import classes from "./BankGuaranteeIssuance.module.css";
import {
  useGetApplicationDataToBankQuery,
  useSendRegistryNumberMutation,
} from "../../../../store/api/applicationBankApi/applicationBank.api";
import { useParams } from "react-router-dom";
import { Guard } from "../../../../utils/guards/Guard";
import { APPLICATION_BANK_STATUS } from "../../../../utils/guards/ApplicationBankStatusGuard/types";
import { useGetPermissionQuery } from "../../../../store/api/permission.api";
import { useForm } from "antd/es/form/Form";
import dayjs from "dayjs";

export const BankGuaranteeIssuance = () => {
  const [form] = useForm();
  const { applicationBankId } = useParams();
  const { data: applicationBankData } = useGetApplicationDataToBankQuery(
    Number(applicationBankId)
  );
  const [sendRegistryNumber, { isLoading: isSendRegistryNumberLoading }] =
    useSendRegistryNumberMutation();

  const { data: permissionData } = useGetPermissionQuery(undefined);

  const initialValues = {
    issuance_bg_date: applicationBankData?.issuance_bg_date
      ? dayjs(applicationBankData?.issuance_bg_date)
      : dayjs(),
    number_register: applicationBankData?.number_register,
  };

  const onFinish = () => {
    if (applicationBankId) {
      sendRegistryNumber({
        applicationBankId: Number(applicationBankId),
        body: {
          ...form.getFieldsValue(),
          issuance_bg_date: form.getFieldValue("issuance_bg_date").format(),
        },
      });
    }
  };

  useEffect(() => {
    form.resetFields();
  }, [
    applicationBankData?.issuance_bg_date,
    applicationBankData?.number_register,
    form,
  ]);

  return (
    <section>
      <BankGuaranteeIssuanceDocuments />
      <Divider orientation="left">Дополнительная информация</Divider>

      <Form form={form} initialValues={initialValues} onFinish={onFinish}>
        <div className={classes.inputRow}>
          <div>
            <div className={classes.inputTitle}>Дата выдачи БГ</div>
            <Form.Item name={"issuance_bg_date"}>
              <DatePicker disabled allowClear={false} format={"DD.MM.YY"} />
            </Form.Item>
          </div>
          <div>
            <div className={classes.inputTitle}>Реестровая запись</div>
            <Form.Item name={"number_register"}>
              <Input
                disabled={
                  !applicationBankData ||
                  applicationBankData.employee_user?.id !==
                    permissionData?.data?.user?.id ||
                  !(
                    applicationBankData.modified_bank_status.type ==
                    APPLICATION_BANK_STATUS.SIGNED_MANAGER
                  )
                }
                prefix={"№"}
              />
            </Form.Item>
          </div>
        </div>

        <Form.Item>
          {applicationBankData &&
            applicationBankData.employee_user?.id ===
              permissionData?.data?.user?.id && (
              <Guard.ApplicationBankStatus
                status={applicationBankData.modified_bank_status.type}
                allowedStatuses={[APPLICATION_BANK_STATUS.SIGNED_MANAGER]}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isSendRegistryNumberLoading}
                >
                  Сохранить
                </Button>
              </Guard.ApplicationBankStatus>
            )}
        </Form.Item>
      </Form>
    </section>
  );
};
